// LiveStreamChatroom.js
import { connect } from 'react-redux';

import {
  LIVESTREAM_CHAT_LIST_LIMITATION,
  LIVESTREAM_CHAT_SCROLL_DETECT_ITEM_COUNT,
} from '../RemoteConfigKeys.js';

import LiveStreamChatroom from '../component/LiveStreamChatroom.jsx';
import getMeData from '../selector/getMeData.js';
import getLiveStreamChats from '../selector/getLiveStreamChats.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import setLiveStreamChatroom from '../action/setLiveStreamChatroom.js';

const mapStateToProps = (state, { streamId }) => {
  const meId = getMeData(state, 'id');
  const chatMessages = getLiveStreamChats(state, streamId);
  const latestMessageId = chatMessages?.[chatMessages?.length - 1]?.id;
  const latestMessageSenderId = getLiveStreamData(
    state,
    [streamId, 'chat', latestMessageId],
    'senderId'
  );
  return {
    meId,
    latestMessageId,
    latestMessageSenderId,
    chatListLimitation: getRemoteConfigData(
      state,
      LIVESTREAM_CHAT_LIST_LIMITATION
    ),
    chatScrollDetectItemCount: getRemoteConfigData(
      state,
      LIVESTREAM_CHAT_SCROLL_DETECT_ITEM_COUNT
    ),
    chatMessages,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setLiveStreamChatroom: ({ isScrolling }) =>
      dispatch(setLiveStreamChatroom({ isScrolling })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStreamChatroom);
